/**
 * Pushes the filters to the dataLayer
 * @param {Object} filters The filters to push to the dataLayer
 */
export default (filters) => {
	window.dataLayer = window.dataLayer || [];
	window.dataLayer.push({
		filters,
	});
};
